import React from 'react';
import { Grid } from '@mui/material';
import type { DefectCode } from '@Types/utils.types';
import { DefectAutoComplete } from './DefectAutoComplete';
import { CalculationInfo } from './CalculationInfo';

interface TrenchDefectFieldsProps {
	system: 'Metric' | 'Imperial';
	defectCodes: string[];
	defectCodeOptions: DefectCode[];
	defectCodesLoading?: boolean;
	onDefectCodesChange: (codes: string[]) => void;
}

// Shared defect-code picker + rehab-length calculation explainer shown
// whenever trench-length costing is selected, used by both the custom-cost
// and cost-table fields.
export const TrenchDefectFields = ({
	system,
	defectCodes,
	defectCodeOptions,
	defectCodesLoading,
	onDefectCodesChange,
}: TrenchDefectFieldsProps) => (
	<>
		<Grid xs={12} item>
			<DefectAutoComplete
				defectCodes={defectCodes}
				defectCodeOptions={defectCodeOptions}
				defectCodesLoading={defectCodesLoading}
				onDefectCodesChange={onDefectCodesChange}
			/>
		</Grid>
		<CalculationInfo system={system} />
	</>
);
